import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // height: '100vh',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    // alignItems: 'center',
    backgroundColor: '#f0f0f0',
    border: '1px solid #ccc',
    width: '70%',
    borderRadius: 5,
    margin: 10,
    // padding: theme.spacing(2)
    // maxWidth: 420,
  },
  gridItemFirst: {
    width: '30%',
    flexBasis: '30%',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  itemDetail: {
    display: 'flex',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    width: '99%',
    minHeight: '10%'
  },
  itemCard: {
    display: 'flex',
    overflowY: 'auto',
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    width: 'inherit',
  },
  cardButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxHeight: 150,
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  description: {
    fontSize: 14,
    textAlign: 'center',
  },
  cardBodyContainer: {
    width: '99%',
    margin: '40px auto 0'
  },
  cardBody: {
    width: '100%'
  },
  cardsContainer: {
    height: '94%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '8px',
  },
  chartInfoContainer: {
    width: '230px',
    margin: '12px auto 0',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: '8px',
    padding: '12px'
  },
  chartInfoTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '14px'
  },
  finishBtn: {
    margin: '40px auto 20px',
    display: 'flex'
  }
}))
